import script from "./ActivityIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityIndicator.vue?vue&type=script&setup=true&lang=js"

import "./ActivityIndicator.vue?vue&type=style&index=0&id=3b0f3878&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b0f3878"]])

export default __exports__